import * as Popper from "popper.js";
import * as React from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DatePickerWrap.scss';

// #region Component Props

interface IProps {
    handleChange        : any;
    dateValue           : Date|null;
    disable?            : boolean;
    classes?            : string;
    renderInline?       : boolean;
    format?             : string;
    name?               : string;

    readOnly?           : boolean;
    highlightDates?     : Date[];

    maxDate?            : Date;
    minDate?            : Date;
    
    maxTime?            : Date;
    minTime?            : Date;
    
    includeDates?       : Date[];
    excludeDates?       : Date[];
    
    includeTimes?       : Date[];
    excludeTimes?       : Date[];

    startDate?          : Date;
    endDate?            : Date;

    inline?             : boolean;
    withPortal?         : boolean;
    popperModifiers?    : Popper.Modifiers;
    placeholder?        : string;

    showLessThan?       : boolean;
    isLessThanChecked?  : boolean;
    onLessThanChecked?  : any;

}

// #endregion

const DatePickerWrapped : React.SFC<IProps> = (props) => {

    const { 
        handleChange, 
        dateValue, 
        classes, 
        renderInline, 
        format, 
        name,
        minDate,
        maxDate,
        disable,
        highlightDates,
        maxTime,
        minTime,
        includeDates,
        excludeDates,
        includeTimes,
        placeholder,
        excludeTimes,
        inline,
        withPortal,
        popperModifiers,
        isLessThanChecked,
        showLessThan,
        onLessThanChecked
    } = props;
    const trueFormat = format ? format : 'MM/dd/yy';

    return <div className={"datepicker-wrap " + (renderInline ? 'render-inline' : '')}>
                <DatePicker      
                    todayButton={"Today"}
                    className={ classes }
                    selected={ dateValue }   
                    name={ name }                       
                    dateFormat={ trueFormat }
                    onChange={ handleChange }
                    disabled={ disable }
                    maxDate={ maxDate ? maxDate : undefined }
                    minDate={ minDate ? minDate : undefined }
                    highlightDates={ highlightDates }
                    maxTime={ maxTime }
                    minTime={ minTime }
                    placeholderText={ placeholder }
                    includeDates={ includeDates }
                    shouldCloseOnSelect={ !showLessThan }
                    excludeDates={ excludeDates }
                    includeTimes={ includeTimes }
                    excludeTimes={ excludeTimes }
                    inline={ inline }
                    withPortal={ withPortal }
                    popperModifiers={ popperModifiers }
                >
                    {
                        showLessThan
                            ? <div className="include-up-to">
                                <label>
                                    <p>Match Day of Week?</p>
                                    <input 
                                        type="checkbox" 
                                        checked={ isLessThanChecked } 
                                        onChange={ () => onLessThanChecked(!isLessThanChecked) }
                                        id="fixed-hours" />
                                </label>
                            </div>
                            : null
                    }
                </DatePicker>
                {
                    showLessThan && dateValue !== undefined && dateValue !== null
                        ? <div className="datepicker-checkbox-label">
                            { isLessThanChecked ? 'Match DOW' : ' <=' }
                        </div>
                        : null
                }
        </div>;
};

DatePickerWrapped.defaultProps = {
    classes         : '',
    renderInline    : false,
    format          : '',
    placeholder     : ''
};

export { DatePickerWrapped };
